import "./FullscreenSpinner.scss";

function FullscreenSpinner({displayText}) {
    return (
        <>
            <div id="overlay"></div>
            <div className="page-loader">
                <div className="loader-wrapper">
                    <div className="lds-ring">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    <p className="loading-text">{displayText}</p>
                </div>
            </div>
        </>
      )
}  
export default FullscreenSpinner;